import React from "react";


const Policies = () => {
    return (
        <div className="my-5">
            <hr className="border-t-2 border-slate-200 py-5" />
            <h1 className="text-2xl font-bold text-slate-800">SUMMARY OF SIGNIFICANT ACCOUNTING POLICIES</h1>

            <div className="p-6 space-y-6 text-slate-800 leading-relaxed">
      <h2 className="text-2xl font-bold text-blue-900">
        1. Basis of the Preparation of the Financial Statements
      </h2>
      <p>
        The <strong>Financial Statements</strong> have been prepared in accordance with{" "}
        <strong>Cash Basis IPSAS</strong>, Financial Reporting under the Cash Basis of Accounting,
        issued by the International Public Sector Accounting Standards Board (IPSASB) and Local
        Authorities Accounting Policies (LAAPs). These financial statements have been prepared in
        accordance with the <strong>historical cost convention</strong> as the basis of measurement,
        unless specified otherwise.
      </p>
      <p>The accounting policies have been applied consistently throughout the period.</p>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">
          1.1 Migration to Accrual Basis Financial Reporting
        </h3>
        <p>
          [council name] Town Council is required, under the{" "}
          <strong>Local Government Act No. 2 of 2019</strong> to produce a Statement of
          Comprehensive Income and a Statement of Financial Position. The production of these
          statements entails adoption and application of <strong>Accrual Basis of Accounting</strong>{" "}
          in financial reporting. However, the Act does not specify which particular accrual basis to
          use. In applying Cash Basis of Accounting, the Council followed guidance listed below:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>(a) Cash Basis IPSAS</strong> — Allows public sector entities adopting Accrual
            Basis for the first time to use Cash Basis provisions as an intermediate step in their
            transition.
          </li>
          <li>
            <strong>(b) Accounting Pronouncement: 2018/3</strong> — Issued by ZICA, requiring adoption
            of Accrual Basis Accounting by public entities by <strong>31st December, 2022</strong>,
            with [council name] Town Council scheduled to adopt by{" "}
            <strong>1st January, 2025</strong>.
          </li>
          <li>
            <strong>(c) Treasury and Financial Management Circular No. 10 of 2019</strong> — Issued
            by the Secretary to the Treasury, outlining a three-year transition (2022–2024) and full
            compliance by <strong>1st January, 2025</strong>.
          </li>
        </ul>
        <p>
          Based on these guidelines, the Council has not yet commenced production of Accrual Basis
          financial statements but has adopted Part 2 Cash Basis IPSAS as a transition step.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.2 Reporting Entity</h3>
        <p>
          The Financial Statements are prepared for <strong>[council name] Town Council (MTC)</strong>.
          They encompass the Council and include projects and activities of the{" "}
          <strong>Constituency Development Fund</strong> and the{" "}
          <strong>Local Government Equalization Fund</strong> in the district.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.3 Authorization Date</h3>
        <p>
          The financial statements were authorized for issue on{" "}
          <span className="italic">[date to be inserted]</span> by the ordinary/special Council.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.4 Revenue</h3>
        <p>
          Revenue is recognized when cash is received. It is generated from various sources,
          including:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Local Taxes:</strong> Levies imposed under Article 161 and the Local Government
            Act for property owners, businesses, or commodity transactions.
          </li>
          <li>
            <strong>Fees and Charges:</strong> Charges for licenses, permits, or services like health
            permits, waste collection, parking fees, and building inspection fees.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.5 Expenditure</h3>
        <p>
          Expenditure is recognized when payment is made. It includes expenses for personal
          emoluments, goods and services, social benefits, and acquisition of non-financial assets.
          Capital items are expensed at payment, and no depreciation or amortization is charged.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.6 Reporting on Gross Basis</h3>
        <p>
          Transactions are reported on a gross basis without netting off similar receipts and
          payments, except where administered for other entities.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">
          1.7 Cash in hand at the Beginning and the End of the Year
        </h3>
        <p>
          Cash includes notes, coins, bank balances, and highly liquid investments with maturities of
          three months or less.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">
          1.8 Local Government Equalization Fund
        </h3>
        <p>
          Parliament appropriates funds annually to the Local Government Equalization Fund to
          supplement local revenue. These funds are used for operational expenses and service
          delivery.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">
          1.9 Constituency Development Fund
        </h3>
        <p>
          The fund supports micro-community projects for poverty reduction. It is regulated by the
          Constituency Development Fund Act No. 11 of 2018, with separate accounts maintained for
          each constituency.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.10 Other Grants</h3>
        <p>
          These include grants in lieu of rates and support from Cooperating Partners, either in cash
          or under bilateral and multilateral agreements.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.11 Presentation Currency</h3>
        <p>The presentation currency is Zambian Kwacha (ZMW).</p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.12 Foreign Currencies</h3>
        <p>
          Foreign currency transactions are converted to ZMW at the exchange rate at payment time.
          Year-end balances are translated at the ruling rate, with differences charged to the
          Statement of Cash Receipts and Payments.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">1.13 Borrowings</h3>
        <p>
          Borrowings include actual cash inflows from financial institutions and bilateral or
          multilateral agreements.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-blue-800">
          1.14 Budgets and Actual Amounts
        </h3>
        <p>
          Budgets include original approvals and subsequent adjustments. Significant variances (20%
          and above) are disclosed and explained in the financial statement notes.
        </p>
      </section>
    </div>
        </div>
    )
}

export default Policies;